export const actions = {
    SET_STREET: 'SET_STREET',
    SET_STREET_NUMBER: 'SET_STREET_NUMBER',
    SET_SUBURB: 'SET_SUBURB',
    SET_STATE: 'SET_STATE',
    SET_CITY: 'SET_CITY',
    SET_COUNTRY: 'SET_COUNTRY',
    SET_FIRST_NAME: 'SET_FIRST_NAME',
    SET_LAST_NAME: 'SET_LAST_NAME',
    SET_EMAIL: 'SET_EMAIL',
    SET_TELEPHONE: 'SET_TELEPHONE',
    SET_POSTCODE: 'SET_POSTCODE',
    SET_ADDRESS_TYPE: 'SET_ADDRESS_TYPE',
    SET_INVALID: 'SET_INVALID',
    UNSET_INVALID: 'UNSET_INVALID',
    RESET_INVALID: 'RESET_INVALID',
    SET_AUTOSUGGEST_RESULT: 'SET_AUTOSUGGEST_RESULT',
    CLEAR_AUTOSUGGEST_RESULT: 'CLEAR_AUTOSUGGEST_RESULT',
};
